import { defineMessages } from "react-intl";

export default defineMessages({
  yourInformationHeader: {
    id: "Appointment.AppointmentCheckoutLinkedPatientForm.yourInformationHeader",
    defaultMessage: "Your information",
  },
  emailLabel: {
    id: "Appointment.AppointmentCheckoutLinkedPatientForm.emailLabel",
    defaultMessage: "Email address",
  },
  phoneNumberLabel: {
    id: "Appointment.AppointmentCheckoutLinkedPatientForm.phoneNumberLabel",
    defaultMessage: "Mobile phone number",
  },
  additionalPhoneLabel: {
    id: "Appointment.AppointmentCheckoutLinkedPatientForm.additionalPhoneLabel",
    defaultMessage: "Additional mobile phone number",
  },
  addAdditionalPhone: {
    id: "Appointment.AppointmentCheckoutLinkedPatientForm.addAdditionalPhone",
    defaultMessage: "+ Add an additional mobile phone number",
  },
  selectPatientHeader: {
    id: "Appointment.AppointmentCheckoutLinkedPatientForm.selectPatientHeader",
    defaultMessage: "Select patient",
  },
  selectButton: {
    id: "Appointment.AppointmentCheckoutLinkedPatientForm.selectButton",
    defaultMessage: "Select",
  },
  addAnotherPatient: {
    id: "Appointment.AppointmentCheckoutLinkedPatientForm.addAnotherPatient",
    defaultMessage: "+ Add another patient",
  },
  requiresGuardian: {
    id: "Appointment.AppointmentCheckoutLinkedPatientForm.requiresGuardian",
    defaultMessage: "Requires parent or legal guardian",
  },
  patientMedicalHeader: {
    id: "Appointment.AppointmentCheckoutLinkedPatientForm.patientMedicalHeader",
    defaultMessage: "Patient medical information",
  },
  heightFtLabel: {
    id: "Appointment.AppointmentCheckoutLinkedPatientForm.heightFtLabel",
    defaultMessage: "Height (ft)",
  },
  heightInLabel: {
    id: "Appointment.AppointmentCheckoutLinkedPatientForm.heightInLabel",
    defaultMessage: "Height (in)",
  },
  weightLbsLabel: {
    id: "Appointment.AppointmentCheckoutLinkedPatientForm.weightLbsLabel",
    defaultMessage: "Weight (lbs)",
  },
  wearingDeviceHeader: {
    id: "Appointment.AppointmentCheckoutLinkedPatientForm.wearingDeviceHeader",
    defaultMessage: "Does the patient have a pacemaker or aneurysm clip?",
  },
  answerYes: {
    id: "Appointment.AppointmentCheckoutLinkedPatientForm.answerYes",
    defaultMessage: "Yes",
  },
  answerNo: {
    id: "Appointment.AppointmentCheckoutLinkedPatientForm.answerNo",
    defaultMessage: "No",
  },
  authErrorMessage: {
    id: "Appointment.AppointmentCheckoutLinkedPatientForm.authErrorMessage",
    defaultMessage:
      "This email is already in use, please confirm authorization or choose another address",
  },
});
